jQuery(function($)
{
    /* CONST */
    var
        liveSearchInQueue = 0,
        liveSearchInQueueForMs = 333,    // Prevents multiple api calls while fast typing
        searchRequestUriReplacePattern = '[searchterm]',
        searchRequestUriLanguageUrlPattern = '[languageUrl]',
        searchRequestUriLanguagePattern = '[language]',
        searchRequestUriDPattern = '[d]',
        searchRequestUriCustomerIdPattern = '[customerId]',
        minTermLength = 2,
        liveSearchRequests = {},
        $body = $('body'),

        /* VARS */
        $searchContainer = $('#site-search'),
        $searchField = $('input#searchterm', $searchContainer),
        $searchFieldButton = $('#searchterm--button', $searchContainer),
        $searchForm = $('form', $searchContainer),
        $searchFormSuggestions = $('.suggestions', $searchContainer),
        $liveSearchResultContainer = $('.output', $searchContainer),
        $liveSearchResults = $('.results', $liveSearchResultContainer),
        $liveSearchSuggestions = $('.suggestions', $liveSearchResults),
        $liveSearchHint = $('.js-hint.min-length', $liveSearchResultContainer),
        $liveSearchPSO = $('.js-pso-container', $liveSearchResultContainer),
        $liveSearchDYM = $('.js-did-you-mean', $liveSearchResultContainer),
        $liveSearchLoadingIndicator = $('.liveSearchLoading'),
        searchRequestUri = $searchField.data('livesearch-request-uri-pattern'),
        localeCode = $('meta[name=localeCode]').attr('content'),
        customerId = '',
        language = (localeCode) ? localeCode.toUpperCase().slice(0, 2) : '',
        languageUrl = language.toLowerCase(),
        discount = $searchField.attr('d'),
        idLastRequest = 0,

        $searchBox = $('.js-auto-input-watch'),
        $searchInput = $('.js-auto-input'),

        /* GLOBALS */
        { hide } = orion,
        show = function(element)
        {
            orion.showExclusive(element, $('.dropdown', '#directorder-main'));
        };

    // use dataLayer for customerId, which is an external dependency so we do some safety-checks
    if (typeof dataLayer !== 'undefined' && typeof dataLayer[0] !== 'undefined')
    {
        customerId = Object.prototype.hasOwnProperty.call(dataLayer[0], 'customerId') ? dataLayer[0]['customerId'] : '';
    }

    /* TRIGGERS */
    $searchField.on('click input', handleInputEvent);
    $searchFieldButton.on('click', handleInputEvent);

    // Hide the live search if clicked "elsewhere"
    $('body').on(orion.constants.EventFocusOverlayClicked, handleDocumentEvent);

    // Hide the examples overlay if clicked ESC key
    $(document).on('keydown', handleKeyDownEvent);

    handleNoResult();

    /* EVENTS */
    function handleNoResult()
    {
        if ($('input.js-no-results').length > 0 && $('.js-did-you-mean').length > 0)
        {
            show($liveSearchResultContainer);
            $body.addClass('focus-active');
            $searchContainer.addClass('active');
            hide($liveSearchPSO);
        }
    }

    function handleDocumentEvent()
    {
        closeLiveSearch();
    }

    function handleKeyDownEvent(event)
    {
        switch (event.keyCode)
        {
        // case "Tab" or "Escape":
        case 9:
        case 27:
            closeLiveSearch();
            break;
        default:
            if ($searchContainer.hasClass('active'))
            {
                $searchField.focus();
            }
        }
    }

    function handleInputEvent(event)
    {
        $body.addClass('focus-active');
        $searchContainer.addClass('active');

        $('body, html').animate({
            'scrollTop': 0
        }, '500');

        var searchTerm = $searchField.val();

        if (event.type == 'click')
        {
            if ($liveSearchResultContainer.hasClass('lsActive'))
            {
                return;
            }

            if (searchTerm.length > 1)
            {
                $searchField.trigger('input');
                return;
            }
        }

        var liveSearch = function()
        {
            var request;

            $(document).on('keydown', handleKeyDownEvent);

            show($liveSearchLoadingIndicator);

            request = makeSearchRequestPromise(language, searchTerm, discount, languageUrl, customerId);
            liveSearchRequests[request.requestId] = request;

            request
                .done(function(response, statusText, jqXHR)
                {
                    var statusCode = jqXHR.status;

                    if (idLastRequest !== request.requestId)
                    {
                        // Stale request => Discard
                        return;
                    }

                    if (statusCode == 200)
                    {
                        liveSearchOverlay('results', response);
                    }
                    else if (statusCode == 404)
                    {
                        if (!$searchFormSuggestions.find('li').length)
                        {
                            liveSearchOverlay('examples');
                        }
                        hide($liveSearchLoadingIndicator);
                    }
                    else
                    {
                        hide($liveSearchLoadingIndicator);
                    }

                    delete liveSearchRequests[request.requestId];
                })
                .fail(function()
                {
                    if (!$searchFormSuggestions.find('li').length)
                    {
                        liveSearchOverlay('examples');
                    }
                    else
                    {
                        moveAutosuggestFromOverlay();
                        hide($liveSearchResultContainer);
                    }
                    hide($liveSearchLoadingIndicator);
                    delete liveSearchRequests[request.requestId];
                });
        };

        clearLiveSearchRequests();

        if (searchTerm.length < minTermLength)
        {
            if (searchTerm === '')
            {
                liveSearchOverlay('examples');
            }
            else
            {
                liveSearchOverlay('hints');
            }
        }
        else
        {
            if (!$liveSearchHint.hasClass('hidden'))
            {
                liveSearchOverlay('none', null, false);
            }

            liveSearchInQueue = setTimeout(liveSearch, liveSearchInQueueForMs);
        }
    }

    function handleLiveSearchButtonClick()
    {
        $('.search-submit').on('click', function()
        {
            $searchForm.submit();
        });
    }

    /* BUSINESS */
    function makeSearchRequestPromise(language, searchTerm, discount, languageUrl, customerId)
    {
        var
            requestUri = getSearchRequestUri(language, searchTerm, discount, languageUrl, customerId),
            request = $.ajax({
                'cache': true,
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = (idLastRequest + 1);
        idLastRequest += 1;

        return request;
    }
    function getSearchRequestUri(language, searchTerm, discount, languageUrl, customerId)
    {
        return searchRequestUri
            .replace(searchRequestUriLanguageUrlPattern, languageUrl)
            .replace(searchRequestUriLanguagePattern, language)
            .replace(searchRequestUriReplacePattern, encodeURIComponent(searchTerm))
            .replace(searchRequestUriDPattern, encodeURIComponent(discount))
            .replace(searchRequestUriCustomerIdPattern, customerId);
    }

    function liveSearchOverlay(part, content, showOverlay, showLoading)
    {
        /* Per default show the overlay on function call */
        if (typeof showOverlay === 'undefined')
        {
            showOverlay = true;
        }

        /* Per default omit the loading indicator */
        if (typeof showLoading === 'undefined')
        {
            showLoading = false;
        }

        if (showOverlay === true)
        {
            if (showLoading === true)
            {
                show($liveSearchLoadingIndicator);
            }
            else
            {
                hide($liveSearchLoadingIndicator);
            }

            hide($liveSearchDYM);

            switch (part)
            {
            case 'none':
                hide($liveSearchResults);
                hide($liveSearchPSO);
                hide($liveSearchHint);
                break;
            case 'results':
                if (typeof content !== 'undefined' && content.length > 0)
                {
                    $liveSearchResults.html(content);
                }

                moveAutosuggestToOverlay();

                show($liveSearchResults);
                hide($liveSearchPSO);
                hide($liveSearchHint);
                break;
            case 'examples':
                if (typeof content !== 'undefined' && content.length > 0)
                {
                    $liveSearchPSO.html(content);
                }

                hide($liveSearchResults);
                show($liveSearchPSO);
                hide($liveSearchHint);
                break;
            case 'hints':
                if (typeof content !== 'undefined' && content.length > 0)
                {
                    $liveSearchHint.html(content);
                }

                hide($liveSearchResults);
                hide($liveSearchPSO);
                show($liveSearchHint);
                break;
            }

            show($liveSearchResultContainer);
            $liveSearchResultContainer.addClass('lsActive');
        }
        else
        {
            moveAutosuggestFromOverlay();

            hide($liveSearchResultContainer);
            hide($liveSearchLoadingIndicator);
            hide($liveSearchResults);
            hide($liveSearchPSO);
            hide($liveSearchHint);
            hide($liveSearchDYM);

            $liveSearchResultContainer.removeClass('lsActive');
        }
    }

    function clearLiveSearchRequests()
    {
        if (parseInt(liveSearchInQueue) > 0)
        {
            clearTimeout(liveSearchInQueue);
        }

        if (typeof liveSearchRequests !== 'undefined')
        {
            var requestId;

            for (requestId in liveSearchRequests)
            {
                if (Object.prototype.hasOwnProperty.call(liveSearchRequests, requestId))
                {
                    liveSearchRequests[requestId].abort();
                    delete liveSearchRequests[requestId];
                }
            }
        }
    }

    function moveAutosuggestToOverlay()
    {
        // Show max 3 search results (originally 5 for B2C)
        $liveSearchResults.find('li.item').slice(3).remove();
        $liveSearchSuggestions = $('.suggestions', $liveSearchResults);
        var $detachedSearchFormSuggestions = $searchFormSuggestions.detach();

        $detachedSearchFormSuggestions.removeClass('dropdown');
        $liveSearchSuggestions.after($detachedSearchFormSuggestions);
        $liveSearchSuggestions.remove();
        $liveSearchSuggestions.focus();
        handleLiveSearchButtonClick();
    }

    function moveAutosuggestFromOverlay()
    {
        $liveSearchSuggestions = $('.suggestions', $liveSearchResults);
        var $detachedLiveSearchSuggestions = $liveSearchSuggestions.detach();

        $detachedLiveSearchSuggestions.addClass('dropdown');
        $searchForm.append($detachedLiveSearchSuggestions);
    }

    function closeLiveSearch()
    {
        liveSearchOverlay('none', null, false);
        $body.removeClass('focus-active');
        $searchContainer.removeClass('active');
        $searchField.val('');
        show($liveSearchPSO);
        $(document).off('keydown');
    }

    // monitoring the width for translations and window sizes
    function handleInputVisibility()
    {
        var isHidden = $searchBox.width() < 145;
        $searchInput.toggleClass('invisible', isHidden);
    }

    $(function()
    {
        handleInputVisibility();
        $(window).on('resize', handleInputVisibility);
    });

    $('.js-close-button').on('click', function()
    {
        closeLiveSearch();
    });

    $('body').on(orion.constants.EventOverlayClosed, closeLiveSearch);
});
